import React from 'react'; 

import TaskDetail from 'components/containers/task/TaskDetail';

const TaskDetailLayout = ({params}) => { 

    return (
        <TaskDetail
            title='인증'
            type='normal' 
            currTaskNo={params['id']}
            animation={false}
         />
    );    
}

export default TaskDetailLayout;